'use client';

import { type ComponentProps, useState } from 'react';
import Link from 'next/link';
import LoadingButton from '@ab-inbev-eu/ui-library/components/basic/LoadingButton';

export function LoadingButtonLink({
  children,
  linkProps,
  buttonProps,
  buttonClasses,
}: {
  children: ComponentProps<typeof LoadingButton>['children'];
  linkProps: ComponentProps<typeof Link>;
  buttonProps?: ComponentProps<typeof LoadingButton>['buttonProps'];
  buttonClasses?: ComponentProps<typeof LoadingButton>['classes'];
}) {
  const [loading, setLoading] = useState(false);
  return (
    <Link {...linkProps}>
      <LoadingButton
        loading={loading}
        buttonProps={{
          ...buttonProps,
          onClick: (e) => {
            setLoading(true);
            buttonProps?.onClick?.(e);
          },
        }}
        classes={buttonClasses}
      >
        {children}
      </LoadingButton>
    </Link>
  );
}
